import { useCallback } from 'react';
import { Handle, Position } from '@xyflow/react';

const handleStyle = { top: 50,  };

export default function IndividualTool({ data, isConnectable }) {

  const onChange = useCallback((evt) => {
    console.log(evt.target.value);
  }, []);

  return (
    <div className="w-20 h-20 p-4 bg-white rounded-lg flex items-center justify-center border border-gray-200 relative">

        <Handle
            type="source"
            position={Position.Top}
            id="c"
            isConnectable={isConnectable}
            style={{ width: "50%", height: 6, borderRadius: '0', backgroundColor: '#ff7675' }}
        /> 

        <div className="text-center text-sm">
        Individual Tool 
        </div>

        

    </div>
)}


